module.exports = __webpack_public_path__ + "images/ExternalPromo/lyrics-160-6.png?69259";